import React from 'react';
import { Section } from './ui/Section';
import { BookOpenIcon, Sun, AlertTriangle, BookHeart, MessageCircleHeart } from 'lucide-react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
const deliverables = [{
  icon: <BookOpenIcon size={28} className="text-terracotta" data-id="element-185" />,
  title: 'Guía Principal (PDF)',
  desc: 'El paso a paso para implementar el Escudo de 3 Segundos.'
}, {
  icon: <Sun size={28} className="text-terracotta" data-id="element-186" />,
  title: 'Protocolo 8 AM',
  desc: 'El sistema para eliminar las batallas matutinas antes de salir a la escuela.'
}, {
  icon: <AlertTriangle size={28} className="text-terracotta" data-id="element-187" />,
  title: 'Checklist SOS',
  desc: 'Una hoja de ruta visual para tus momentos de crisis.'
}, {
  icon: <BookHeart size={28} className="text-terracotta" data-id="element-188" />,
  title: 'Diario de Gatillos',
  desc: 'Para identificar qué es lo que realmente te hace perder el control.'
}, {
  icon: <MessageCircleHeart size={28} className="text-terracotta" data-id="element-189" />,
  title: 'Guion de Respuestas Rápidas',
  desc: 'Qué decir cuando el susurro es más poderoso que el grito.'
}];
export const WhatYouGet = () => {
  return <Section className="bg-white" data-id="element-190">
      <div className="text-center mb-16" data-id="element-191">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-charcoal mb-4" data-id="element-192">
          Todo lo que recibes hoy
        </h2>
        <p className="text-lg text-charcoal/70" data-id="element-193">
          Herramientas prácticas, directas y sin relleno.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-194">
        {deliverables.map((item, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="bg-beige/20 border border-border/50 rounded-2xl p-8 hover:shadow-soft transition-shadow" data-id="element-195">
            <div className="bg-white w-14 h-14 rounded-xl flex items-center justify-center shadow-sm mb-6" data-id="element-196">
              {item.icon}
            </div>
            <h3 className="text-xl font-serif font-semibold text-charcoal mb-3" data-id="element-197">
              {item.title}
            </h3>
            <p className="text-charcoal/70 leading-relaxed" data-id="element-198">{item.desc}</p>
          </motion.div>)}
      </div>

      <div className="flex justify-center" data-id="element-199">
        <Button onClick={() => document.getElementById('offer')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-200">
          ¡QUIERO MI GUÍA Y RECUPERAR MI PAZ AHORA!
        </Button>
      </div>
    </Section>;
};